import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import useCommon from "hooks/useCommon";
import usePermissions from "hooks/usePermissions";
import Cookies from "js-cookie";
import VuiBox from "components/VuiBox";
import { verifySession } from "store/slice/userSlice";

/**
 *  - permission?: string   -> permission key to check (e.g. "viewDashboard")
 *  - redirectTo?: string   -> where to send unauthenticated users (default: /authentication/sign-in)
 */

const RequireAuth = ({ route, permission, children }) => {
  const { STORE, DISPATCH } = useCommon();
  const { canView, getFirstAllowedRoute } = usePermissions();
  const { authInitialized, isAuthenticated, user } = STORE((state) => state.user);

  if (!authInitialized) {
    return (
      <VuiBox display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress color="primary" />
      </VuiBox>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  if (permission && !canView(permission, route)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default RequireAuth;
